import '../plugins/loadMorePlugin';

export function initLoadMore() {
	return jQuery('.load-more-holder').loadMore({
		linkSelector: 'a.btn--load',
    dataType: 'text'
	});
}
